import { Camelized, Decamelized } from 'humps'

export type Handler = () => void
export type HandlerOf<T> = (value: T) => void
export type HandlerOfOptional<T> = (value?: T) => void

export type NoNullFields<Ob> = Required<{ [K in keyof Ob]: NonNullable<Ob[K]> }>

export function noNullFields<T>(value: T) {
  return value as NoNullFields<T>
}

export type DeepPartial<T> = {
  [P in keyof T]?: DeepPartial<T[P]>
}

export type AddPrefixToObject<T, P extends string> = {
  [K in keyof T as K extends string ? `${P}${K}` : never]: T[K]
}

type Truthy<T> = T extends false | '' | 0 | null | undefined ? never : T // from lodash

export function truthy<T>(value: T): value is Truthy<T> {
  return !!value
}

export interface PaginatedResults<T> {
  count: number
  next: 'string'
  previous: 'string'
  results: T[]
}

export type WithRequiredProperty<Type, Key extends keyof Type> = Type & {
  [Property in Key]-?: Type[Property]
}

export type SnakeToCamelCase<S extends string> = S extends `${infer T}_${infer U}`
  ? `${T}${Capitalize<SnakeToCamelCase<U>>}`
  : S

export type CamelToSnakeCase<S extends string> = S extends `${infer T}${infer U}`
  ? `${T extends Capitalize<T> ? '_' : ''}${Lowercase<T>}${CamelToSnakeCase<U>}`
  : S

export type CamelToSnakeCaseNested<T> = Decamelized<T>

export type SnakeToCamelCaseNested<T> = Camelized<T>

export type WithExclusiveOneOf<T, X, Y> = T &
  (
    | ({
        [K in keyof X]: X[K]
      } & {
        [K in keyof Y]?: never
      })
    | ({
        [K in keyof Y]: Y[K]
      } & {
        [K in keyof X]?: never
      })
  )
